import {
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  MuiThemeProvider,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { enTheme, IThemeCustomizerModel } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ColorPicker from './ColorPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IThemeCustomizerModel;
  themeId: enTheme;
}

@WithStyles(() => ({
  inputBorderWidth: {
    '& input': {
      textAlign: 'right'
    }
  },
  inputBorderStyle: {
    marginTop: 16,
    width: '100%'
  },
  title: {
    overflow: 'hidden',
    padding: '12px 0',
    '&:after': {
      content: '""',
      display: 'inline-block',
      height: '0.5em',
      verticalAlign: 'bottom',
      width: '100%',
      marginRight: '-100%',
      marginLeft: 10,
      borderTop: '1px solid #D8D8D8'
    }
  }
}))
export default class Form extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null, themeId: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.combineLatest(themeCustomizerService.getThemeId())
      )
      .subscribe(([model, themeId]) => {
        this.setState({ model, themeId });
      });
  }

  onChangeHeaderBackground = (color: string) => {
    themeCustomizerService.setData({
      header: {
        ...this.state.model.header,
        bgcolor: color
      }
    });
  };

  onChangeHeaderFontColor = (color: string) => {
    themeCustomizerService.setData({
      header: {
        ...this.state.model.header,
        font: { ...this.state.model.header.font, color }
      }
    });
  };

  onChangeTitleColor = (color: string) => {
    themeCustomizerService.setData({
      labels: {
        font: {
          ...this.state.model.labels.font,
          color
        }
      }
    });
  };

  onChangeFontColor = (color: string) => {
    themeCustomizerService.setData({
      inputs: {
        ...this.state.model.inputs,
        font: {
          ...this.state.model.inputs.font,
          color
        }
      }
    });
  };

  onChangeFooterFontColor = (color: string) => {
    themeCustomizerService.setData({
      footer: {
        ...this.state.model.footer,
        font: {
          ...this.state.model.footer.font,
          color
        }
      }
    });
  };

  onChangeInputBackground = (color: string) => {
    themeCustomizerService.setData({
      inputs: {
        ...this.state.model.inputs,
        bgcolor: color
      }
    });
  };

  onChangeBorderColor = (color: string) => {
    themeCustomizerService.setData({
      inputs: {
        ...this.state.model.inputs,
        border: {
          ...this.state.model.inputs.border,
          color
        }
      }
    });
  };

  onChangeInputBorderStyle = (event: any) => {
    themeCustomizerService.setData({
      inputs: {
        ...this.state.model.inputs,
        border: {
          ...this.state.model.inputs.border,
          style: event.target.value
        }
      }
    });
  };

  onChangeBorderWidth = (event: any) => {
    themeCustomizerService.setData({
      inputs: {
        ...this.state.model.inputs,
        border: {
          ...this.state.model.inputs.border,
          size: event.target.value
        }
      }
    });
  };

  render() {
    const { classes } = this.props;
    const { model, themeId } = this.state;

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        {themeId === enTheme.HOTSITE && (
          <div>
            <Typography variant="h6" className={classes.title}>
              Cabeçalho
            </Typography>
            <ColorPicker value={model.header.bgcolor} label="Fundo" handleChangeColor={this.onChangeHeaderBackground} />
            <ColorPicker
              label="Cor das Letras"
              value={model.header.font.color}
              handleChangeColor={this.onChangeHeaderFontColor}
            />
          </div>
        )}
        <Typography variant="h6" className={classes.title}>
          Campos de texto
        </Typography>
        <ColorPicker
          label="Cor do Título"
          value={model.labels.font.color}
          handleChangeColor={this.onChangeTitleColor}
        />
        <ColorPicker
          label="Cor das Letras"
          value={model.inputs.font.color}
          handleChangeColor={this.onChangeFontColor}
        />
        {themeId === enTheme.PADRAO && (
          <ColorPicker
            label="Cor de Fundo do Campo"
            value={model.inputs.bgcolor}
            handleChangeColor={this.onChangeInputBackground}
          />
        )}
        <TextField
          label="Espessura da Borda"
          id="input-border-width"
          value={model.inputs.border.size}
          type="number"
          margin="normal"
          fullWidth
          InputProps={{
            endAdornment: <InputAdornment position="end">px</InputAdornment>,
            disableUnderline: true,
            className: classes.inputBorderWidth
          }}
          inputProps={{
            type: 'number',
            min: 0
          }}
          onChange={this.onChangeBorderWidth}
        />
        <ColorPicker
          label="Cor da Borda"
          value={model.inputs.border.color}
          handleChangeColor={this.onChangeBorderColor}
        />
        <Grid item xs={12}>
          <FormControl className={classes.inputBorderStyle}>
            <InputLabel htmlFor="input-border-style">Estilo da Borda</InputLabel>
            <Select
              value={model.inputs.border.style || 'solid'}
              onChange={this.onChangeInputBorderStyle}
              name="inputBorderStyle"
              displayEmpty
              autoWidth={false}
              disableUnderline={true}
              inputProps={{
                name: 'inputBorderStyle',
                id: 'input-border-style'
              }}
            >
              <MenuItem value="solid">Linha</MenuItem>
              <MenuItem value="dotted">Pontilhado</MenuItem>
              <MenuItem value="dashed">Traçado</MenuItem>
              <MenuItem value="double">Duplicado</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {/* {themeId === enTheme.PADRAO &&
          <div>
            <Typography variant='title' className={classes.title}>
              Rodapé
            </Typography>
            <ColorPicker
              value={model.footer.font.color}
              label='Cor da Letra'
              handleChangeColor={this.onChangeFooterFontColor}
            />
          </div>
        } */}
      </MuiThemeProvider>
    );
  }
}
